module.exports = __webpack_public_path__ + "src/img/galerie/innenrenovierung/Bad-Nachher.jpg";